module.exports = __webpack_public_path__ + "media/images/products/category/sm/3-bec5c31d47cc9e5e76e184b29635a0fe.jpg";